const options = {
  5: "bg-stone-300/5",
  10: "bg-stone-300/10",
  25: "bg-stone-300/25",
  50: "bg-stone-300/50",
  75: "bg-stone-300/75",
  90: "bg-stone-300/90",
  100: "bg-stone-300",
};

const from = {
  5: "from-stone-300/5",
  10: "from-stone-300/10",
  25: "from-stone-300/25",
  50: "from-stone-300/50",
  75: "from-stone-300/75",
  90: "from-stone-300/90",
  100: "from-stone-300",
};

export default function getBackgroundStone300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
